export const ROLE = {
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_COMMERCIAL: 'ROLE_COMMERCIAL',
    ROLE_CONSULTANT: "ROLE_CONSULTANT",
    ROLE_DIRECTION: 'ROLE_DIRECTION',
    ROLE_DELIVERY_MANAGER: 'ROLE_DELIVERY_MANAGER',
    ROLE_TALENT_MANAGER: 'ROLE_TALENT_MANAGER',
    ROLE_MANAGER: "ROLE_MANAGER",
    ROLE_ACQUISITION_MANAGER: 'ROLE_TALENT_ACQUISITION_MANAGER',
    TESTEUR: 'ROLE_TESTEUR'
};
